var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-modal',{attrs:{"show":_vm.show,"size":"small"},on:{"close":_vm.close}},[_c('request-action-confirm',{attrs:{"request":_vm.fromBus.request,"action":_vm.fromBus.action},on:{"close":_vm.close}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }